import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';
import CategoryItems  from './CategoryItems.jsx';


export class GiftShopCarousel extends Component {

    constructor(props) {
        super(props);
        this.state = {
          activeIndex: 0,
          visibleBooksCount: 5
        };
        this.slidesNum = props.activeFilterResult.products ? props.activeFilterResult.products.length : 0;
        this.arrowClick = this.arrowClick.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
    }

    arrowClick(direction) {
        let { visibleBooksCount, activeIndex } = this.state,
            slidesNum = this.slidesNum;
        if (direction === 'back') {
            if (activeIndex >= visibleBooksCount) activeIndex -= visibleBooksCount;
            else activeIndex = slidesNum - ( activeIndex - visibleBooksCount );
        } else {
            if (activeIndex < slidesNum - visibleBooksCount) activeIndex += visibleBooksCount;
            else  activeIndex = (activeIndex + visibleBooksCount) % slidesNum;
        }
        this.setState({ activeIndex: activeIndex});
    }

    updateDimensions(){
      let width = document.body.clientWidth;
      if( width <= 551  && this.state.visibleBooksCount !== 2 ) this.setState({ visibleBooksCount: 2 });
      else if( width > 551  && width <= 850  && this.state.visibleBooksCount !== 4 ) this.setState({ visibleBooksCount: 4 });
      else if( width > 850 && this.state.visibleBooksCount !== 5 ) this.setState({ visibleBooksCount: 5 });
    }

    componentDidMount() {
        this.updateDimensions();
        //this.carouselInterval = setInterval(()=> {
        //    this.arrowClick('forward');
        //}, 6000);
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        clearInterval(this.carouselInterval);
        window.removeEventListener("resize", this.updateDimensions);
    }

    render() {
        let {visibleBooksCount, activeIndex } = this.state,
            slidesNum = this.slidesNum,
            activeFilterResult = this.props.activeFilterResult,
            products = activeFilterResult.products;
        if(products){
          products = products.slice( activeIndex, activeIndex + visibleBooksCount);
          if(products.length < visibleBooksCount) products = products.concat( activeFilterResult.products.slice(0, visibleBooksCount - products.length) );
        }
        let books = <CategoryItems products={products} />

        return (
          <div className="bottom-genre carouselSlidesWrapper">
              {books}
              <div
                  className={"pointer left" + ((true) ? '' : ' hide') }
                  onClick={this.arrowClick.bind(this,"backward")}
              >
                  <svg version="1.1"x="0px" y="0px" width="18.25px" height="34px" viewBox="0 0 18.25 34" enableBackground="new 0 0 18.25 34">
                      <polygon fill="rgba(255,255,255,.5)" points="17.157,0.343 0.257,17.244 17.014,34 18.029,32.985 2.288,17.243 18.172,1.357 "/>
                  </svg>
              </div>
              <div
                  className={"pointer right" + ((true) ? '' : ' hide') }
                  onClick={this.arrowClick.bind(this, "forward")}
              >
                  <svg version="1.1" x="0px" y="0px" width="18.25px" height="34px" viewBox="0 0 18.25 34" enableBackground="new 0 0 18.25 34">
                      <polygon fill="rgba(255,255,255,.5)" points="1.35,34.001 18.25,17.1 1.493,0.344 0.478,1.358 16.22,17.101 0.335,32.986 "/>
                  </svg>
              </div>
          </div>
        );
    }
};

function mapStateToProps(state){
    return { 'activeFilterResult' : state.activeFilterResult };
}

export default connect(mapStateToProps)(GiftShopCarousel);


// WEBPACK FOOTER //
// ./src/components/GiftShopCarousel.jsx